module.exports = __webpack_public_path__ + "static/media/WhipAround_android_2.68cad590.jpg";